import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { API } from "@/config";
import axios from "axios";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = hash.split("session_id=")[1]?.split("&")[0];

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    const processSession = async () => {
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const res = await axios.get(`${API}/auth/session`, {
          params: { session_id: sessionId },
          withCredentials: true,
        });
        setUser(res.data);
        // Force OAuth users to complete the full registration form on first login.
        // (checks phone, address, civility, birth_date, marital_status, SSN, ID doc, etc.)
        if (res.data.role !== "admin" && res.data.profile_complete === false) {
          navigate("/auth?complete=1", { replace: true, state: { user: res.data } });
          return;
        }
        const destination = res.data.role === "admin" ? "/admin" : "/dashboard";
        navigate(destination, { replace: true, state: { user: res.data } });
      } catch (err) {
        console.error("Auth callback error:", err);
        navigate("/auth", { replace: true });
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#662483] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#3F3F3F] font-medium">Connexion en cours...</p>
      </div>
    </div>
  );
}
